module.exports = __webpack_public_path__ + "img/questionMark@2x.6398c711.png";